import Vue from 'vue'
import Router from 'vue-router'
import * as Cookies from 'tiny-cookie'

import Login from '../page/Login'
import Layout from '../page/Layout'
import _404 from '../page/404'
import Setting from '../page/Setting'

const Index = () => import('../page/Index')
const Homework = () => import('../page/homework/Homework')
const HomeworkTask = () => import('../page/homework/Task')
const HomeworkTopic = () => import('../page/homework/Topic')
const HomeworkTaskForm = () => import('../page/homework/TaskForm')
const HomeworkTopicForm = () => import('../page/homework/TopicForm')
const HomeworkList = () => import('../page/homework/List')
const HomeworkPublish = () => import('../page/homework/Publish')
const OrganizationTeacher = () => import('../page/organization/Teacher')
const OrganizationStudent = () => import('../page/organization/Student')
const OrganizationCourse = () => import('../page/organization/Course')
const OrganizationCourseLesson = () => import('../page/organization/CourseLesson')
const OrganizationCourseTeacher = () => import('../page/organization/CourseTeacher')
const OrganizationCourseStudent = () => import('../page/organization/CourseStudent')
const OrganizationStudentCourse = () => import('../page/organization/StudentCourse')
const OrganizationLesson = () => import('../page/organization/Lesson')
Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      component: Login
    },
    {
      path: '/home',
      component: Layout,
      redirect: '/index',
      children: [
        {
          path: '/index',
          component: Index
        },
        {
          path: '/setting',
          component: Setting
        },
        {
          path: '/homework',
          component: Homework,
          redirect: '/homework/publish',
          children: [
            {
              path: 'student',
              component: OrganizationStudent
            },
            {
              path: 'student/:id/course',
              component: OrganizationStudentCourse
            },
            {
              path: 'teacher',
              component: OrganizationTeacher
            },
            {
              path: 'task',
              component: HomeworkTask
            },
            {
              path: 'course',
              component: OrganizationCourse
            },
            {
              path: 'lesson',
              component: OrganizationLesson
            },
            {
              path: 'course/:id/lesson',
              component: OrganizationCourseLesson
            },
            {
              path: 'course/:id/teacher',
              component: OrganizationCourseTeacher
            },
            {
              path: 'course/:id/student',
              component: OrganizationCourseStudent
            },
            {
              path: 'task/form/:taskid',
              component: HomeworkTaskForm
            },
            {
              path: 'topic',
              component: HomeworkTopic
            },
            {
              path: 'topic/form',
              component: HomeworkTopicForm
            },
            {
              path: 'topic/form/:taskid',
              component: HomeworkTopicForm
            },
            {
              path: 'homework',
              component: HomeworkList
            },
            {
              path: 'publish',
              component: HomeworkPublish
            }
          ]
        }
      ]
    },
    {
      path: '*',
      component: _404
    }
  ]
})

router.beforeEach((to, from, next) => {
  let access_token = Cookies.get('access_token')

  if (to.path === '/') {
    // 去登录页
    if (access_token) {
      // 已登录 跳转首页
      next('/index')
    } else {
      // 登录态失效
      next()
    }
  } else {
    // 去其他页
    if (!access_token) {
      // 登录态失效 跳转首页
      next({
        path: '/',
        redirect: to.path
      })
    } else {
      // 已登录 跳转目标页
      next()
    }
  }
})

export default router
